import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "ar_right",
  "use": "ar_right-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"ar_right\">\n<path d=\"M8.99966 17.5897C8.61039 17.2004 8.61004 16.5694 8.99889 16.1797L12.875 12.2951L8.99889 8.41047C8.61004 8.02078 8.61039 7.38975 8.99966 7.00047C9.38923 6.6109 10.0209 6.6109 10.4104 7.00047L15.705 12.2951L10.4104 17.5897C10.0209 17.9793 9.38923 17.9793 8.99966 17.5897Z\" fill=\"#003595\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol